import {Component, EventEmitter, Input, Output} from '@angular/core';
import XLSX from 'xlsx';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-import-btn',
  templateUrl: './import-btn.component.html'
})
export class ImportBtnComponent {

  @Input() isDisabled: boolean = false;
  @Output() uploadFileEvent: EventEmitter<any> = new EventEmitter<any>();
  async emitEvent(event: { files: (Blob)[]; },form: { clear: () => void; }){
    const data: any = await this.readFileToJson(event.files[0])
    this.uploadFileEvent.emit(data);
    form.clear();
  }

  constructor(private messageService: MessageService) {}

  private readFileToJson(file:any){
    return new Promise((resolve,reject)=>{
      try {
        const reader = new FileReader()
        reader.onload = (event) => {
          const sheetData = reader.result
          const workBook = XLSX.read(sheetData, {type: 'binary' })
          const sheetName = workBook.SheetNames[0]
          const sheet = workBook.Sheets[sheetName]
          const rows = XLSX.utils.sheet_to_json(sheet, {raw: false, dateNF: 'yyyy-mm-dd', defval: ''})
          return resolve(this.formatObjectKeys(rows))
        }
        reader.readAsBinaryString(file)
      } catch (error) {
        return resolve([])
      }
    })
  }
  private formatObjectKeys(data: any) {
    return data.map((row:any) => {
      const formattedObj: { [key: string]: any } = {};
      Object.keys(row).forEach((key) => {
        const formattedKey = this.toCamelCase(key);
        if (formattedKey.includes("-")) {
          formattedObj[formattedKey.replace(/-/g, "")] = row[key];
        } else if (formattedKey.toLocaleLowerCase().includes("date")) {
          formattedObj[formattedKey] =  new Intl.DateTimeFormat('en-US').format(new Date((row[key])));
        } else {
          formattedObj[formattedKey] = row[key];
        }
      });
      return formattedObj;
    });
  }

  private toCamelCase(str:string) {
    const capitalizedStr = str.replace(/\b\w/g, match => match.toUpperCase())
    return capitalizedStr.replace(/\s+/g, '')
  }
  private getDate(totalDays:number) {
    let millisecondsPerDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    let days = 25569
    return new Date((totalDays - days) * millisecondsPerDay)
  }

}
